import React from "react";
import { Redirect, Route } from "react-router-dom";
import ROUTES from "../config/RouteNames";
import DashboardRoutes from "./DashboardRoutes";
import { getFromLocal } from "../utils/Cache";
import { LOCAL_STORAGE_KEYS } from "config/constants";
import jwt from "jsonwebtoken";

const PrivateRoute = (path: any) => {
  const auth = getFromLocal(LOCAL_STORAGE_KEYS.auth)?.auth;
  const token = auth?.token;
  const decodedToken: any = jwt.decode(token);
  const userChannel = decodedToken?.userChannel;

  return (
    <Route
      render={(props) =>
        getFromLocal("auth") && userChannel === "COMMANDO" ? (
          <DashboardRoutes {...props} />
        ) : (
          <Redirect
            to={{
              pathname: ROUTES.LOGIN,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
